import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable()
export class RoleGuard implements CanActivate {
    menuPermissions: any = [];
    area: any = [];
    privilege: any;
    isPermissionGiven: any;
    isPermissionGivenForView: any;
    isPermissionGivenForAdd: any;
    isPermissionGivenForEdit: any;
    isPermissionGivenForDelete: any;
    currentRouteURL: string;

    constructor(private _router: Router, private toastr: ToastrService) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
        this.menuPermissions = JSON.parse(localStorage.getItem('UserPermissions'));
        if(!this.menuPermissions) {
            if(localStorage.getItem('AccessToken') == undefined || localStorage.getItem('AccessToken') == null) {
                  window.location.href = environment.apiClientPath + '/login';
                  return EMPTY;
            }
        } else {
        for (let i = 0; i < this.menuPermissions.length; i++) {
            this.area[i] = this.menuPermissions[i].area;
            if (this.area[i] === next.data.roleName) {
                this.currentRouteURL = state.url;
                //View
              if (next.data.role == 'View' || next.data.role == 'WIPView') {     
                if(next.data.roleName === "Timesheet"){
                    if(JSON.parse(this.menuPermissions[i].privilege)[0].Value == 'True' || JSON.parse(this.menuPermissions[i].privilege)[1].Value == 'True' || JSON.parse(this.menuPermissions[i].privilege)[2].Value == 'True'){
                       return true; 
                    }
                }
                
                if(next.data.roleName === "Settings"){
                    const privilege = JSON.parse(this.menuPermissions[i].privilege).filter(item => item.Key == "StaffBudget");
                    if(privilege.length > 0 && privilege[0].Key == "StaffBudget" && next.routeConfig.path == "staff-budget"){
                        if(privilege[0]?.Value == 'True') {
                            return true; 
                        } else {
                            this.toastr.error("You don't have permission to access this page");
                            this._router.navigate(['/client/Noaccess']);
                        }
                    }
                }

                if(next.data.roleName === "Billing"){
                    const privilege = JSON.parse(this.menuPermissions[i].privilege).filter(item => item.Key == "Payment");
                    if(privilege.length > 0 && privilege[0].Key == "Payment" && (this.currentRouteURL.includes('/payments/bank-statements') || this.currentRouteURL.includes('/payments/reconcile'))){
                        if(privilege[0]?.Value == 'True') {
                            return true; 
                        } else {
                            this.toastr.error("You don't have permission to access this page");
                            return this.currentRouteURL.includes('/billing/billing-details') ? this._router.createUrlTree(['/billing/billing-details']) : this._router.createUrlTree(['/billing/billings']);
                        }
                    }
                }

                this.isPermissionGivenForView = JSON.parse(this.menuPermissions[i].privilege)[0].Value;
                    if (this.isPermissionGivenForView == 'True') {
                        return true;
                    } else {
                        
                        this.toastr.error("You don't have permission to access this page");
                      this._router.navigate(['/client/Noaccess']);
                    }
                }
                //Add
                if (next.data.role == 'Add') {
                    this.isPermissionGivenForAdd = JSON.parse(this.menuPermissions[i].privilege)[1].Value;
                    if (this.isPermissionGivenForAdd == 'True') {
                        return true;
                    } else {
                 
                        this.toastr.error("You don't have permission to access this page");
                      this._router.navigate(['/client/Noaccess']);
                    }
                }
            }
        }
        return false;
      }
    }
}
